import { motion } from "framer-motion"
import { Worker, Viewer } from "@react-pdf-viewer/core"
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout"
import { Icon } from "@/components/Atoms/Icon"

import "@react-pdf-viewer/core/lib/styles/index.css"
import "@react-pdf-viewer/default-layout/lib/styles/index.css"

interface PDFModalProps {
  url: string
  onClose: () => void
  title: string
}

export const PDFModal = ({ url, onClose, title }: PDFModalProps) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    sidebarTabs: (defaultTabs) => [],
    renderToolbar: (Toolbar) => (
      <Toolbar>
        {(slots) => {
          const {
            CurrentPageInput,
            GoToNextPage,
            GoToPreviousPage,
            Download,
            NumberOfPages,
            Zoom,
            ZoomIn,
            ZoomOut,
          } = slots
          return (
            <div className="flex w-full items-center justify-between px-2">
              <div className="flex items-center gap-1">
                <GoToPreviousPage />
                <div className="flex items-center text-sm">
                  <CurrentPageInput /> / <NumberOfPages />
                </div>
                <GoToNextPage />
              </div>
              <div className="flex items-center gap-1">
                <ZoomOut />
                <Zoom />
                <ZoomIn />
              </div>
              <div>
                <Download />
              </div>
            </div>
          )
        }}
      </Toolbar>
    ),
  })

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="relative flex h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-xl border border-white/10 bg-[#1a1a1a] shadow-2xl"
      >
        {/* Header Customizado */}
        <div className="flex items-center justify-between border-b border-white/10 bg-zinc-900 p-4">
          <h3 className="truncate text-sm font-semibold text-zinc-300">{title}</h3>
          <button
            onClick={onClose}
            className="rounded-sm bg-zinc-800 p-2 text-zinc-400 transition-colors hover:text-white"
          >
            <Icon name="x" />
          </button>
        </div>

        {/* Container do PDF */}
        <div className="flex-1 overflow-hidden bg-zinc-800">
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={url}
              plugins={[defaultLayoutPluginInstance]}
              theme="dark"
            />
          </Worker>
        </div>
      </motion.div>
    </div>
  )
}
